@if (!formArray) {
  <spinner></spinner>
}

@if (visOpretKnap) {
  <button
    type="button"
    class="opret-note"
    mat-fab
    color="primary"
    matTooltip="Ny note"
    matTooltipPosition="left"
    (click)="onOpretClick()"
    aria-label="Ny note"
    >
    <mat-icon svgIcon="plus"></mat-icon>
  </button>
}

<mat-accordion #accordion>
  @for (note of synligeNoter; track note) {
    <mat-expansion-panel
      #expansionPanel
      (opened)="onPanelOpened(note)"
      (closed)="onPanelClosed(note)"
      [attr.data-noteid]="note.get('noteId').value"
      [id]="'note_' + note.get('noteId').value"
      >
      <mat-expansion-panel-header>
        <div class="scroll-margin-top"></div>
        <accordion-status-indicator [formGroup]="note"></accordion-status-indicator>
        <mat-panel-title
          ><span>{{ note.value.overskrift }}</span></mat-panel-title
          >
          <mat-panel-description>{{ hentOmraadeTekst(note) }}</mat-panel-description>
          <div class="buttons">
            @if (skalSletKnapVises(expansionPanel)) {
              <button mat-button type="button" (click)="onSletClick($event, note)" color="warn">
                SLET
              </button>
            }
            @if (skalGemKnapVises(expansionPanel, note)) {
              <button
                mat-button
                Id="qa-note-liste-component-gem-button"
                type="button"
                (click)="onGemClick($event, note)"
                color="primary"
                [disabled]="!note.valid || !note.dirty"
                >
                GEM
              </button>
            }
          </div>
          <mat-chip-list>
            <div class="mat-chip mat-standard-chip">{{ note.value.antalBilag }} bilag</div>
          </mat-chip-list>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        @if (expansionPanel.expanded) {
          <div class="note-content">
            @if (!note.value.fullyLoaded) {
              <spinner></spinner>
            }
            @if (note.value.fullyLoaded) {
              <note #notePanel [formGroup]="note"></note>
            }
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
